import React from "react";
import { images } from "/src/constant/index";
import GoogleLogin from "react-google-login";
import { Helmet } from "react-helmet";
import { NavLink, withRouter } from "react-router-dom";
import {BASE_URL, validateEmail, hideAlertAfterDelay} from "../../helper";
import API from "../../api";
import "../../assets/css/password.css";
import { withSnackbar } from "notistack";
import { instanceOf } from "prop-types";
import { Cookies, withCookies } from "react-cookie";
import { setUserInfo } from "../../actions/user";
import { connect } from "react-redux";
import { GET_USER_INFO } from "../../constants";
import store from "../../store";
import { updateCart } from "../../actions/cart";
import { updateList } from "../../actions/list";
const api = new API();
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";
import "../../assets/css/notification.css";
import "../../assets/css/input.css";
import queryString from "querystring";
import ReCAPTCHA from "react-google-recaptcha";
const eye = <FontAwesomeIcon icon={faEye} />;
const closeEye = <FontAwesomeIcon icon={faEyeSlash} />;

class Login extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      redirect_url : "",
      passwordShown: false,
      rem_me: false,
      loginData: {
        email: "",
        password: "",
      },
      token: this.props.cookies.get("token"),
      errors: {},
      checkout: false,
      loading: false,
      errorAlert: null,
      touched: this.getInitialTouchedState(),
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.rememberHandler = this.rememberHandler.bind(this);
    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
    this.handleCookieAssignment = this.handleCookieAssignment.bind(this);
    this.recaptchaRef = React.createRef();
  }

  componentDidMount() {
    if (
        this.props.cookies.get("token") &&
        this.props.cookies.get("token") !== undefined &&
        this.props.cookies.get("token") !== ""
    ) {
      this.props.history.push("/");
    }
    if (
        this.props.cookies.get("remember") &&
        this.props.cookies.get("remember") !== undefined &&
        this.props.cookies.get("remember") !== ""
    ) {
      if (this.props.cookies.get("remember").rem_me === true) {
        this.setState({
          loginData: {
            email: this.props.cookies.get("remember").email,
            password: this.props.cookies.get("remember").password,
          },
          rem_me: true,
        });
      }
    }
    if (
        this.props.cookies.get("toggle") &&
        this.props.cookies.get("toggle") !== undefined &&
        this.props.cookies.get("toggle") === "toggled"
    ) {
      this.props.cookies.set("toggle", "");
    }

    const params = queryString.parse(this.props.location.search);
    if (params && params['?ref'] !== this.state.redirect_url){
       this.setState({redirect_url : params['?ref'] !== undefined ? params['?ref'] : "" })
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
        this.props.cookies.get("toggle") &&
        this.props.cookies.get("toggle") !== undefined &&
        this.props.cookies.get("toggle") === "toggled"
    ) {
      this.props.cookies.set("toggle", "");
    }
  }

  handleCookieAssignment(success) {
    const { cookies } = this.props;
    const token = success?.data?.response?.token;

    let data = {};
    data.user = success?.data?.response;

    const oneYearFromNow = new Date();
    oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);

    localStorage.setItem('auth_user', success?.data?.response?.first_name + " " + success?.data?.response?.last_name);
    cookies.set("token", token, { expires: oneYearFromNow });
    cookies.set("list_unique_id", success?.data?.response?.list_unique_id || "default", { expires: oneYearFromNow });

    if (success?.data?.response?.cart?.cart_id){
      cookies.set("cart_id", success?.data?.response?.cart?.cart_id, { expires: oneYearFromNow });
      cookies.set("selected_store", success?.data?.response?.cart?.restaurant_id, { expires: oneYearFromNow });
      cookies.set("selected_preference", success?.data?.response?.cart?.preference, { expires: oneYearFromNow });
      cookies.set("delivery_address", success?.data?.response?.cart?.preferred_address, {expires: oneYearFromNow});
    }

    cookies.set("store_modal", false, { expires: oneYearFromNow });
    cookies.set("toggle", "", { expires: oneYearFromNow });

    this.setState({ token });
    this.props.updateUserList({ token: token });
    this.props.updateCartItems({ cart_id: success?.data?.response?.cart?.cart_id || "blank", token: token });
    this.props.userInfo(data);
    this.setState({
      loginData: { email: "", password: "" },
      errors: {},
      touched: this.getInitialTouchedState(),
      loading: true,
    });

    this.props.history.push("/"+this.state.redirect_url);
  }

  responseGoogle = (response) => {

    if (response.profileObj) {
      api
          .googleAuth(
              {
                first_name: response.profileObj.givenName,
                last_name: response.profileObj.familyName,
                coupon_email: false,
                email: response.profileObj.email,
                contact_number: "",
                google_id: response.profileObj.googleId,
                password: response.profileObj.email + response.profileObj.googleId,
                confirm_password:
                    response.profileObj.email + response.profileObj.googleId,
              },
              this.props.cookies.get("cart_id")
                  ? this.props.cookies.get("cart_id")
                  : "blank",
              this.props.cookies.get("list_unique_id")
                  ? this.props.cookies.get("list_unique_id")
                  : "default"
          )
          .then((success) => {
            this.handleCookieAssignment(success);
          });
    }
  };

  togglePasswordVisibility = () => {
    this.setState({ passwordShown: !this.state.passwordShown});
  };

  getLoginFieldNames() {
    return ["email", "password"];
  }

  getInitialTouchedState() {
    return this.getLoginFieldNames().reduce((touched, name) => {
      touched[name] = false;
      return touched;
    }, {});
  }

  getAllTouchedState() {
    return this.getLoginFieldNames().reduce((touched, name) => {
      touched[name] = true;
      return touched;
    }, {});
  }

  getFieldValidationError(name, value) {
    if (name === "email") {
      return !value || !validateEmail(value) ? "Enter valid email address" : "";
    }

    if (name === "password") {
      return !value ? "Enter password" : "";
    }

    return "";
  }

  getFormValidationErrors(loginData = this.state.loginData) {
    const errors = {};

    this.getLoginFieldNames().forEach((name) => {
      const error = this.getFieldValidationError(name, loginData[name]);

      if (error) {
        errors[name] = error;
      }
    });

    return errors;
  }

  showValidationErrors(errors, extraState = {}) {
    this.setState({
      errors,
      touched: this.getAllTouchedState(),
      ...extraState,
    });
  }

  handleChange(event) {
    const {name} = event.target;
    const value = event.target.value.replace(/\s/g, '');
    const loginData = {...this.state.loginData, [name]: value};
    const errors = {...this.state.errors};

    // Keep first typing quiet; once a field is touched, validate on change so visible errors clear immediately.
    if (this.state.touched[name]) {
      const fieldError = this.getFieldValidationError(name, value);

      if (fieldError) {
        errors[name] = fieldError;
      } else {
        delete errors[name];
      }
    }

    this.setState({loginData, errors, errorAlert: null});
  }

  handleBlur(event) {
    const {name} = event.target;
    const errors = {...this.state.errors};
    const fieldError = this.getFieldValidationError(name, this.state.loginData[name]);

    if (fieldError) {
      errors[name] = fieldError;
    } else {
      delete errors[name];
    }

    this.setState({
      touched: {
        ...this.state.touched,
        [name]: true,
      },
      errors,
    });
  }

  rememberHandler(event) {
    const result =
        event.target.type === "checkbox"
            ? event.target.checked
            : event.target.value;
    this.setState({ rem_me: result });
    const { cookies } = this.props;
    if (result === true) {
      cookies.set("remember", {
        rem_me:
            event.target.type === "checkbox"
                ? event.target.checked
                : event.target.value,
        email: this.state.loginData.email,
        password: this.state.loginData.password,
      });
    } else {
      cookies.set("remember", {
        rem_me:
            event.target.type === "checkbox"
                ? event.target.checked
                : event.target.value,
        email: "",
        password: "",
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    const errors = this.getFormValidationErrors();

    if (Object.keys(errors).length > 0) {
      this.showValidationErrors(errors, {errorAlert: null});
      return false;
    }

    // Local validation runs before reCAPTCHA so invalid forms do not trigger captcha work.
    this.recaptchaRef.current.execute();
  }

  onReCAPTCHAChange = (token) => {

    this.setState({errorAlert: null});

    const errors = this.getFormValidationErrors();

    if (Object.keys(errors).length > 0) {
      this.showValidationErrors(errors);
      this.recaptchaRef.current.reset();
      return false;
    }

    const loginData = {
      ...this.state.loginData,
      cart_id: this.props.cookies.get("cart_id") ? this.props.cookies.get("cart_id") : "blank",
      list_unique_id: this.props.cookies.get("list_unique_id") ? this.props.cookies.get("list_unique_id") : "default",
      captcha_token: token,
    };

    api.login(loginData)
        .then((success) => {
          if (success.data.status == "400") {
            this.recaptchaRef.current.reset();
            this.setState({
              errors: {},
              errorAlert: success.data.message,
            });
          } else {
            this.handleCookieAssignment(success);
          }

          // clear previous timer
          if (this.alertTimeout) {
            clearTimeout(this.alertTimeout);
          }
      
          // start new timer
          this.alertTimeout = hideAlertAfterDelay(() => {
              this.setState({ errorAlert: null });
          });
        })
        .catch((error) => {
          this.recaptchaRef.current.reset();
          this.setState({
            errors: {},
            errorAlert: error?.response?.data?.message,
          });

          // clear previous timer
          if (this.alertTimeout) {
              clearTimeout(this.alertTimeout);
          }
      
          // start new timer
          this.alertTimeout = hideAlertAfterDelay(() => {
              this.setState({ errorAlert: null });
          });
        });
  };

  render() {
    return (
        <React.Fragment>

          <Helmet>
            <meta charSet="utf-8"/>
            <title>Login - Farmer&#039;s Fresh Meat: Houston Meat Market &amp;
              Butcher Shop</title>
            <meta name="description"
                  content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
            <meta name="robots" content="index, follow"/>
            <meta name="googlebot"
                  content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
            <meta property="og:type" content="article"/>
            <meta property="og:title" content="Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston"/>
            <meta property="og:description"
                  content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
            <meta property="og:url" content={BASE_URL() + this.props.location.pathname}/>
            <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop"/>
            <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat"/>
            <meta property="article:modified_time" content="2022-02-28T13:10:39+00:00"/>
            <meta property="og:image" content={images.logoImg}/>
            <meta property="og:image:width" content="1449"/>
            <meta property="og:image:height" content="1024"/>
            <meta name="twitter:card" content="summary"/>
            <meta name="twitter:creator" content="Farmerfreshmeat"/>
            <meta name="twitter:site" content="Farmerfreshmeat"/>
            <link rel="canonical" href={BASE_URL() + this.props.location.pathname}/>
            <script type="application/ld+json"
                    className="yoast-schema-graph">{` {"@context":"https://schema.org","@graph":[{"@type":"Organization","@id":"https://farmersfreshmeat.com/#organization","name":"Farmer's Fresh Meat","url":"https://farmersfreshmeat.com/","sameAs":["https://www.facebook.com/farmersfreshmeat","https://www.instagram.com/farmersfreshmeat/","https://www.youtube.com/user/farmersfreshmeat","https://www.pinterest.com/Farmerfreshmeat/","https://twitter.com/Farmerfreshmeat"],"logo":{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/#logo","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2015/03/Farmers_Fresh_Meat_Logo.png","width":312,"height":79,"caption":"Farmer's Fresh Meat"},"image":{"@id":"https://farmersfreshmeat.com/#logo"}},{"@type":"WebSite","@id":"https://farmersfreshmeat.com/#website","url":"https://farmersfreshmeat.com/","name":"Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop","description":"Farmers Fresh Meat","publisher":{"@id":"https://farmersfreshmeat.com/#organization"},"potentialAction":[{"@type":"SearchAction","target":"https://farmersfreshmeat.com/?s={search_term_string}","query-input":"required name=search_term_string"}],"inLanguage":"en-US"},{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2019/09/Leg-Quarters-3-scaled.jpg","width":1449,"height":1024},{"@type":"WebPage","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#webpage","url":"https://farmersfreshmeat.com/shop/leg-quarters/","name":"Fresh Chicken Leg Quarters By the Pound - On Sale now!","isPartOf":{"@id":"https://farmersfreshmeat.com/#website"},"primaryImageOfPage":{"@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage"},"datePublished":"2019-09-23T15:14:32+00:00","dateModified":"2022-02-28T13:10:39+00:00","description":"Fresh Chicken Leg Quarters on Sale and Priced per pound. Hormone free and cut free of charge. The best price and quality at Farmer's Fresh Meat!","inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://farmersfreshmeat.com/shop/leg-quarters/"]}]}]}`}</script>
          </Helmet>

          <section className="main-height form-view d-block pb-5 bg-white pt-2">
            <div className="container">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-9 col-lg-7 col-xl-6 px-md-5 mx-auto">
                  <div className="bg-white border-1 main-section p-3 p-md-5">
                    <div className="signin-info text-center mt-0">
                      <h1 className="mb-2">Login</h1>
                      <div className="col-12 create-account mb-4 text-center ">
                        <p className="text-black font-weight-normal">
                            <span className="font-weight-normal text-black">Don't have an account ?&nbsp;</span>
                            <NavLink className="more-info fs-14 float-none" exact
                                   to={"/signup?ref=" + this.state.redirect_url}>
                              <span className='text-decoration-underline pointer font-weight-medium'>Sign up</span>
                          </NavLink>
                        </p>
                      </div>
                    </div>
                              {this.state.errorAlert ? (
                                  <div role="alert" class="sc-1wz9i2x-0 fooVeK">
                                    <svg
                                        width="1792"
                                        height="1792"
                                        viewBox="0 0 1792 1792"
                                        xmlns="http://www.w3.org/2000/svg"
                                        aria-hidden="true"
                                        class="sc-1t1e23j-0 bbiirI"
                                    >
                                      <path
                                          fill="currentColor"
                                          d="M1024 1375v-190q0-14-9.5-23.5T992 1152H800q-13 0-22.5 9.5T768 1185v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zm-2-374l18-459q0-12-10-19-13-11-24-11H786q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zm-14-934l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17H128q-34 0-63.5-17T18 1601q-37-63-2-126L784 67q17-31 47-49t65-18 65 18 47 49z"
                                      ></path>
                                    </svg>
                                    <span>{this.state.errorAlert}</span>
                                  </div>
                              ) : null}
                              <form>
                                <div className="row">
                                  <div className="form-group col-12">
                                    {/*<label>Email address</label>*/}
                                    <input
                                        type="email"
                                        className={
                                          "form-control valid-control " +
                                          (this.state.errors.email ? "invalid" : "")
                                        }
                                        id="email"
                                        name="email"
                                        placeholder="Email*"
                                        value={this.state.loginData.email}
                                        onChange={this.handleChange}
                                        onBlur={this.handleBlur}
                                    />
                                    <span className="error-text mt-1 mb-1">
                            {this.state.errors.email}
                          </span>
                                  </div>

                                  <div className="form-group col-12">
                                    {/*<label>Password</label>*/}
                                    <input
                                        type={
                                          this.state.passwordShown
                                              ? "text"
                                              : "password"
                                        }
                                        className={
                                          "form-control valid-control " +
                                          (this.state.errors.password ? "invalid" : "")
                                        }
                                        id="password"
                                        placeholder="Password*"
                                        name="password"
                                        value={this.state.loginData.password}
                                        onChange={this.handleChange}
                                        onBlur={this.handleBlur}
                                    />

                                    <i className="hidePassword"
                                       onClick={this.togglePasswordVisibility}>
                                      {this.state.passwordShown ? eye : closeEye}
                                    </i>
                                    <small>8 characters | No spaces</small>
                                    <span className="error-text mt-0 mb-1">
                            {this.state.errors.password}
                        </span>
                                  </div>
                                </div>

                                <div className="form-captcha">
                                  <ReCAPTCHA
                                      ref={this.recaptchaRef}
                                      sitekey={process.env.RAZZLE_RECAPTCHA_SITE_KEY}
                                      onChange={this.onReCAPTCHAChange}
                                      size={"invisible"}
                                  />
                                </div>

                                <div className="row mb-4 align-items-center">
                                  <div className="col pr-1 custom-check login-check">
                                    {/*<div className="custom-check login-check">*/}
                                    {/*    <label className="check ">*/}
                                    {/*        <input className="form-check-input"*/}
                                    {/*            type="checkbox"*/}
                                    {/*            name="rem_me"*/}
                                    {/*            id="rem_me"*/}
                                    {/*        />*/}
                                    {/*        <label className="form-check-label" htmlFor="rem_me">*/}
                                    {/*            <p className="font-regular">Keep me signed in. <a*/}
                                    {/*                href="#">Details</a></p>*/}
                                    {/*        </label>*/}
                                    {/*    </label>*/}
                                    {/*<label className="check ">*/}
                                    {/*  <input*/}
                                    {/*    className="form-check-input"*/}
                                    {/*    type="checkbox"*/}
                                    {/*    name="rem_me"*/}
                                    {/*    id="rem_me"*/}
                                    {/*    onChange={this.rememberHandler}*/}
                                    {/*    checked={this.state.rem_me}*/}
                                    {/*  />*/}
                                    {/*  <span className="checkmark" htmlFor="rem_me"></span>*/}
                                    {/*  Keep me signed in.*/}
                                    {/*</label>*/}
                                    <label className="control control--checkbox mb-0">
                                      Keep me signed in.
                                      <input
                                          className="form-check-input"
                                          type="checkbox"
                                          name="rem_me"
                                          id="rem_me"
                                          onChange={this.rememberHandler}
                                          checked={this.state.rem_me}
                                      />
                                      <div className="control__indicator"></div>
                                    </label>
                                  </div>
                                  <div className="col-auto pl-0 forget-details">
                                    <NavLink className="pl-0 more-info" exact to="/forgot-password">
                                      Forgot your password ?
                                    </NavLink>
                                  </div>
                                </div>
                                <div
                                    className="update-btn"
                                    onClick={(e) => {
                                      this.handleSubmit(e);
                                    }}
                                >
                                  <a className="btn btn-cart w-100">
                                    {this.state.loading ? "Loading..." : "Login"}
                                  </a>
                                </div>

                                {/*<div className="row kpx_row-sm-offset-3 kpx_loginOr">*/}
                                {/*  <div className="col-xs-12 col-xl-12">*/}
                                {/*    <hr className="kpx_hrOr" />*/}
                                {/*    <span className="kpx_spanOr">or</span>*/}
                                {/*  </div>*/}
                                {/*</div>*/}

                                {/*<div className="google-sign text-center">*/}
                                {/*  <h6 className="login-title">Login with</h6>*/}
                                {/*  <GoogleLogin*/}
                                {/*    clientId="49679088522-ojq4n519tk8aopb3ekmm44r6bgbc00oi.apps.googleusercontent.com"*/}
                                {/*    render={(renderProps) => (*/}
                                {/*      <div*/}
                                {/*        className="google-button d-flex justify-content-center"*/}
                                {/*        onClick={renderProps.onClick}*/}
                                {/*      >*/}
                                {/*        <div className="google-icon">*/}
                                {/*          <img src={images.googleIcon} alt="Google" />*/}
                                {/*        </div>*/}

                                {/*        <div className="google-content">*/}
                                {/*          <h6>Sign in with google</h6>*/}
                                {/*        </div>*/}
                                {/*      </div>*/}
                                {/*    )}*/}
                                {/*    onSuccess={this.responseGoogle}*/}
                                {/*    onFailure={this.responseGoogle}*/}
                                {/*    cookiePolicy={"single_host_origin"}*/}
                                {/*  />*/}
                                {/*</div>*/}
                              </form>
                            </div>

                          </div>
                        </div>
                      </div>
                    </section>
        </React.Fragment>
  );
  }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      userInfo: (data) =>
          dispatch(setUserInfo({type: "GET_USER_INFO", data: data})),
      updateCartItems: (val) =>
          dispatch(updateCart({type: "UPDATE_CART_ITEMS", data: val})),
      updateUserList: (val) =>
          dispatch(updateList({type: "USER_LIST", data: val})),
    };
  };
  export default withRouter(
  withCookies(withSnackbar(connect(null, mapDispatchToProps)(Login)))
  );
